import './Subiecte.css';

export default function Subiecte2026() {
    return (
        <div className="container my-4">
            <h2 className="fw-bold mb-4 subjectTitle">{'<'}Subiecte 2026{'/>'}</h2>
            <div className="mb-4">
                <h5>1. <strong>August</strong></h5>
                <ul className="ms-3">
                    <li>
                        <strong>Specializarea Matematică-Informatică:</strong>
                        <ul className="ms-3">
                            <li>
                                <a href="/subiecte/2026/SubiectAugust2026MIC.pdf" target="_blank" rel="noreferrer">
                                    Subiect C/C++
                                </a>
                            </li>
                            <li>
                                <a href="/subiecte/2026/BaremAugust2026MI.pdf" target="_blank" rel="noreferrer">
                                    Barem
                                </a>
                            </li>
                        </ul>
                    </li>
                    <li className="mt-2">
                        <strong>Specializarea Științele-Naturii:</strong>
                        <ul className="ms-3">
                            <li>
                                <a href="/subiecte/2026/SubiectAugust2026SNC.pdf" target="_blank" rel="noreferrer">
                                    Subiect C/C++
                                </a>
                            </li>
                            <li>
                                <a href="/subiecte/2026/BaremIunie2026SN.pdf" target="_blank" rel="noreferrer">
                                    Barem
                                </a>
                            </li>
                        </ul>
                    </li>
                </ul>
                <h5>2. <strong>Iunie</strong></h5>
                <ul className="ms-3">
                    <li>
                        <strong>Specializarea Matematică-Informatică:</strong>
                        <ul className="ms-3">
                            <li>
                                <a href="/subiecte/2026/SubiectIunie2026MIC.pdf" target="_blank" rel="noreferrer">
                                    Subiect C/C++
                                </a>{" "}
                                |{" "}
                                <a href="/subiecte/2026/SubiectIunie2026MIPascal.pdf" target="_blank" rel="noreferrer">
                                    Subiect Pascal
                                </a>
                            </li>
                            <li>
                                <a href="/subiecte/2026/BaremIunie2026MI.pdf" target="_blank" rel="noreferrer">
                                    Barem
                                </a>
                            </li>
                        </ul>
                    </li>
                    <li className="mt-2">
                        <strong>Specializarea Matematică-Informatică (Rezervă):</strong>
                        <ul className="ms-3">
                            <li>
                                <a href="/subiecte/2026/SubiectRezerva2026MIC.pdf" target="_blank" rel="noreferrer">
                                    Subiect C/C++
                                </a>
                            </li>
                            <li>
                                <a href="/subiecte/2026/BaremRezerva2026MI.pdf" target="_blank" rel="noreferrer">
                                    Barem
                                </a>
                            </li>
                        </ul>
                    </li>
                    <li className="mt-2">
                        <strong>Specializarea Științele-Naturii:</strong>
                        <ul className="ms-3">
                            <li>
                                <a href="/subiecte/2026/SubiectIunie2026SNC.pdf" target="_blank" rel="noreferrer">
                                    Subiect C/C++
                                </a>
                            </li>
                            <li>
                                <a href="/subiecte/2026/BaremIunie2026SN.pdf" target="_blank" rel="noreferrer">
                                    Barem
                                </a>
                            </li>
                        </ul>
                    </li>
                </ul>
                <h5>3. <strong>Sesiunea Specială</strong></h5>
                <ul className="ms-3">
                    <li>
                        <strong>Specializarea Matematică-Informatică:</strong>
                        <ul className="ms-3">
                            <li>
                                <a href="/subiecte/2026/SubiectSpeciala2026MIC.pdf" target="_blank" rel="noreferrer">
                                    Subiect C/C++
                                </a>
                            </li>
                            <li>
                                <a href="/subiecte/2026/BaremSpeciala2026MI.pdf" target="_blank" rel="noreferrer">
                                    Barem
                                </a>
                            </li>
                        </ul>
                    </li>
                    <li className="mt-2">
                        <strong>Specializarea Științele-Naturii:</strong>
                        <ul className="ms-3">
                            <li>
                                <a href="/subiecte/2026/SubiectSpeciala2026SNC.pdf" target="_blank" rel="noreferrer">
                                    Subiect C/C++
                                </a>
                            </li>
                            <li>
                                <a href="/subiecte/2026/BaremSpeciala2026SN.pdf" target="_blank" rel="noreferrer">
                                    Barem
                                </a>
                            </li>
                        </ul>
                    </li>
                </ul>
                <h5>4. <strong>Simulare</strong></h5>
                <ul className="ms-3">
                    <li>
                        <strong>Specializarea Matematică-Informatică:</strong>
                        <ul className="ms-3">
                            <li>
                                <a href="/subiecte/2026/SubiectSimulare2026MIC.pdf" target="_blank" rel="noreferrer">
                                    Subiect C/C++
                                </a>{" "}
                                |{" "}
                                <a href="/subiecte/2026/SubiectSimulare2026MIPascal.pdf" target="_blank" rel="noreferrer">
                                    Subiect Pascal
                                </a>
                            </li>
                            <li>
                                <a href="/subiecte/2026/BaremSimulare2026MI.pdf" target="_blank" rel="noreferrer">
                                    Barem
                                </a>
                            </li>
                        </ul>
                    </li>
                    <li className="mt-2">
                        <strong>Specializarea Științele-Naturii:</strong>
                        <ul className="ms-3">
                            <li>
                                <a href="/subiecte/2026/SubiectSimulare2026SNC.pdf" target="_blank" rel="noreferrer">
                                    Subiect C/C++
                                </a>{" "}
                                |{" "}
                                <a href="/subiecte/2026/SubiectSimulare2026SNPascal.pdf" target="_blank" rel="noreferrer">
                                    Subiect Pascal
                                </a>
                            </li>
                            <li>
                                <a href="/subiecte/2026/BaremSimulare2026SN.pdf" target="_blank" rel="noreferrer">
                                    Barem
                                </a>
                            </li>
                        </ul>
                    </li>
                </ul>
                <h5>5. <strong>Model</strong></h5>
                <ul className="ms-3">
                    <li>
                        <strong>Specializarea Matematică-Informatică:</strong>
                        <ul className="ms-3">
                            <li>
                                <a href="/subiecte/2026/SubiectModel2026MIC.pdf" target="_blank" rel="noreferrer">
                                    Subiect C/C++
                                </a>{" "}
                                |{" "}
                                <a href="/subiecte/2026/SubiectModel2026MIPascal.pdf" target="_blank" rel="noreferrer">
                                    Subiect Pascal
                                </a>
                            </li>
                            <li>
                                <a href="/subiecte/2026/BaremModel2026MI.pdf" target="_blank" rel="noreferrer">
                                    Barem
                                </a>
                            </li>
                        </ul>
                    </li>
                    <li className="mt-2">
                        <strong>Specializarea Științele-Naturii:</strong>
                        <ul className="ms-3">
                            <li>
                                <a href="/subiecte/2026/SubiectModel2026SNC.pdf" target="_blank" rel="noreferrer">
                                    Subiect C/C++
                                </a>{" "}
                                |{" "}
                                <a href="/subiecte/2026/SubiectModel2026SNPascal.pdf" target="_blank" rel="noreferrer">
                                    Subiect Pascal
                                </a>
                            </li>
                            <li>
                                <a href="/subiecte/2026/BaremModel2026SN.pdf" target="_blank" rel="noreferrer">
                                    Barem
                                </a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
        </div>
    );
}